export function h3d(ctx) {
    return {
        styles: {
            main: {
                bg_color: `${ctx.SCR_GRAD}ff`,
                border_color: `${ctx.BORDER}ff`,
                border_width: 2,
                outline_color: `${ctx.primary}ff`,
                shadow_color: '#00000066',
                radius: 5,
            },
        },
    };
}
